export const formatRelativeDate = (dateString, language) => {
    const d = new Date(dateString);
    const diffSeconds = Math.floor((Date.now() - d) / 1000);
    const rtf = new Intl.RelativeTimeFormat(language, { numeric: 'auto' });

    if (diffSeconds < 60) return rtf.format(-diffSeconds, 'second');
    if (diffSeconds < 3600) return rtf.format(-Math.floor(diffSeconds / 60), 'minute');
    if (diffSeconds < 86400) return rtf.format(-Math.floor(diffSeconds / 3600), 'hour');
    if (diffSeconds < 604800) return rtf.format(-Math.floor(diffSeconds / 86400), 'day');

    return new Intl.DateTimeFormat(language).format(d);
};

export const formatTime = (dateString, language) =>
    new Intl.DateTimeFormat(language, { hour: '2-digit', minute: '2-digit' }).format(new Date(dateString));
